<div *ngIf="loading">
    <ngx-loading [show]="loading"></ngx-loading>
</div>